import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/floors',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/floors/inventory',
      method: 'get',
      params
    })
  }
  

export function show(id) {
    return request({
      url: `/floors/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/floors',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/floors/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/floors/${id}`,
      method: 'delete',
    })
  }
